import type { AppVersionPlatformConfig } from "../../../app_config/app_config_service.js";
import { MessageReader } from "../../message_handlers/message_reader.js";

export class AppVersionResponse
{
  public android: AppVersionPlatformConfig | null = null;
  public ios: AppVersionPlatformConfig | null = null;

  public deserialize( reader: MessageReader ): void
  {
    reader.readBody();
    this.android = AppVersionResponse.parsePlatform( reader.getBodyElement<unknown>( 'android' ) );
    this.ios = AppVersionResponse.parsePlatform( reader.getBodyElement<unknown>( 'ios' ) );
  }

  private static parsePlatform( raw: unknown ): AppVersionPlatformConfig | null
  {
    if ( !raw || typeof raw !== 'object' ) return null;
    const rec = raw as Record<string, unknown>;
    const to_build = ( v: unknown ): number =>
    {
      const n = typeof v === 'number' ? v : Number( v );
      return Number.isFinite( n ) ? Math.max( 0, Math.floor( n ) ) : 0;
    };
    const store_url = typeof rec.store_url === 'string' ? rec.store_url.trim() : '';
    return { hard: to_build( rec.hard ), soft: to_build( rec.soft ), store_url };
  }
}
